enum PhoneTypes {
  Main = 'main',
  Mobile = 'mobile',
  Work = 'work',
  Home = 'home',
  Fax = 'fax'
}

export default PhoneTypes;
